import {
  Typography,
  List,
  ListItemAvatar,
  ListItemText,
  ListItem,
  Paper,
  makeStyles,
  Avatar,
} from "@material-ui/core";
import React, { useMemo } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { SubmissionsState } from "../redux/state";
import { distanceAgo } from "@ofqual/portal-core/core/utils/dateUtils";
import { useFieldLookups } from "@ofqual/portal-core/core/hooks";
import { cachingSystemSourcesService } from "../services";
const SVR_SEARCH_STATE_KEY = "svrSearch";

const useStyles = makeStyles((theme) => ({
  submissionRowDetails: {
    paddingRight: "20px",
  },
  submissionRow: {
    ...theme.list.itemPrimary,
  },
  submissionRowDisabled: {
    ...theme.list.itemDisabled,
  },
}));

export const RisksList: React.FC<{ submissionsState: SubmissionsState }> = ({
  submissionsState,
}) => {
  const classes = useStyles();

  const { response } = submissionsState;
  const history = useHistory();
  const { pathname, search } = useLocation();
  const navigate = (id: string) =>
    history.push(`${pathname}/${id}`, {
      [SVR_SEARCH_STATE_KEY]: search,
    });

  const sourceIdsPresent = useMemo(
    () => response.data.map((item) => item.submissionSources).flat(),
    [response]
  );

  const sourceLookups = useFieldLookups(
    { service: cachingSystemSourcesService, label: "tag" },
    sourceIdsPresent
  );

  return sourceLookups ? (
    <Paper>
      <List disablePadding>
        {response.data.map((item, index) => (
          <React.Fragment key={item.id}>
            <ListItem
              button
              alignItems="flex-start"
              onClick={() => navigate(item.id)}
              divider
              className={
                item.active
                  ? classes.submissionRow
                  : classes.submissionRowDisabled
              }
              data-test="user-row"
            >
              <ListItemAvatar>
                <Avatar>{item.submissionType === 0 ? "A" : "S"}</Avatar>
              </ListItemAvatar>
              <ListItemText
                primary={
                  <Typography component="span" variant="h6" color="textPrimary">
                    {item.subject}
                  </Typography>
                }
                secondary={
                  <React.Fragment>
                    <Typography
                      className={classes.submissionRowDetails}
                      component="span"
                      variant="body2"
                      color="textPrimary"
                    >
                      <strong>Reported:</strong> {distanceAgo(item.createdDate)}
                    </Typography>
                    <Typography
                      className={classes.submissionRowDetails}
                      component="span"
                      variant="body2"
                      color="textPrimary"
                    >
                      <strong>Reported By:</strong> {item.createdByDisplayName}
                    </Typography>
                    {item.submissionSources && item.submissionSources.length ? (
                      <Typography
                        className={classes.submissionRowDetails}
                        component="span"
                        variant="body2"
                        color="textPrimary"
                      >
                        <strong>Sources:</strong>{" "}
                        {item.submissionSources
                          .map((source) => sourceLookups[source])
                          .join(", ")}
                      </Typography>
                    ) : null}

                    <Typography
                      className={classes.submissionRowDetails}
                      component="span"
                      variant="body2"
                      color="textPrimary"
                    >
                      <strong>Status:</strong>{" "}
                      {item.active ? "Active" : "Deactivated"}
                    </Typography>
                  </React.Fragment>
                }
              />
            </ListItem>
          </React.Fragment>
        ))}
      </List>
    </Paper>
  ) : null; //todo: skeletons;
};
